import * as React from "react";
const SvgWarning = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 12, viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 11.875H13.75L6.875 0L0 11.875ZM7.5 10H6.25V8.75H7.5V10ZM7.5 7.5H6.25V5H7.5V7.5Z", fill: "#FF4A23" }));
export default SvgWarning;
